export default __webpack_public_path__ + "static/media/commas-inverted.09ee0634.svg";